module.exports = __webpack_public_path__ + "img/regularClass.f1bd8a2e.png";